
import { useState, useEffect } from 'react';
import { isValid, parseISO } from 'date-fns';

/**
 * Hook to manage booking details like time and capacity
 */
export const useBookingDetails = (
  selectedClass: any | null,
  dateString: string
) => {
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [availableSlots, setAvailableSlots] = useState<number>(1);
  const [totalCapacity, setTotalCapacity] = useState<number>(0);
  // `dateString` peut être vide ou absent (dialogue ouvert sans date) :
  // `parseISO` lève sur une entrée non-chaîne et `format` lève sur une date
  // invalide — en plein rendu React. On retombe sur aujourd'hui.
  const parsedDate = typeof dateString === 'string' && dateString ? parseISO(dateString) : null;
  const selectedDate = parsedDate && isValid(parsedDate) ? parsedDate : new Date();

  // Initialize with class details when available
  useEffect(() => {
    if (selectedClass) {
      setSelectedTime(selectedClass.time);
      setTotalCapacity(selectedClass.capacity);
      setAvailableSlots(selectedClass.capacity - (selectedClass.attendance || 0));
    }
  }, [selectedClass]);

  // Handle time change
  const handleTimeChange = (newTime: string) => {
    setSelectedTime(newTime);
  };

  // Handle slots/capacity change
  const handleSlotsChange = (newValue: number) => {
    setTotalCapacity(newValue);
  };

  return {
    selectedDate,
    selectedTime,
    handleTimeChange,
    availableSlots,
    setAvailableSlots,
    handleSlotsChange,
    totalCapacity,
    setTotalCapacity
  };
};
